function cartPropsKey(cartProps?: { CODE: string; NAME: string; VALUE: string }[]) {
  return cartProps?.length ? JSON.stringify(cartProps) : "";
}

export function isProductInBasket(basket: any, product: any) {
  if (!product?.ID || !basket?.ITEMS?.length) {
    return false;
  }
  const propsKey = cartPropsKey(product.CART_PROPS);
  return basket.ITEMS.some((item: any) => {
    if (+product.ID !== +item.PRODUCT_ID) {
      return false;
    }
    if (!propsKey) {
      return !item.CART_PROPS?.length;
    }
    return cartPropsKey(item.CART_PROPS) === propsKey;
  });
}
